'use client';

import { useTranslations } from 'next-intl';
import { useRegionLocale } from 'contexts/RegionLocaleContext';
import styles from './DesktopCarouselBanner.module.css';

/* const ShippingIcon = () => (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.38912 12.8921L7.39535 16.2348C7.80136 16.4549 8.19863 16.4597 8.60463 16.2348L14.6098 12.8921C15.2992 12.5081 15.6281 12.1029 15.6281 11.1226V4.92606C15.6281 4.20801 15.3514 3.75079 14.7429 3.41305L9.29053 0.358963C8.43907 -0.119654 7.56086 -0.119654 6.70467 0.358963L1.25713 3.41305C0.648637 3.75079 0.371918 4.20801 0.371918 4.92606V11.1226C0.371918 12.1029 0.700777 12.5081 1.38912 12.8921ZM2.11745 11.89C1.68466 11.6513 1.55501 11.4131 1.55501 11.0081V5.3302L7.38937 8.59925V14.8405L2.11745 11.89ZM13.8825 11.89L8.61062 14.8405V8.59925L14.4449 5.3302V11.0081C14.4449 11.4131 14.3153 11.6513 13.8825 11.89ZM7.99996 7.5186L2.19998 4.2888L4.51172 2.9834L10.3245 6.22654L7.99996 7.5186ZM11.5674 5.53678L5.74449 2.2974L7.25164 1.45332C7.75659 1.16947 8.24232 1.16258 8.74727 1.45332L13.8 4.2888L11.5674 5.53678Z"
      fill="white"
    />
  </svg>
); */

const Battery = () => (
  <svg
    width="22"
    height="10"
    viewBox="0 0 22 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_2323_6928)">
      <path
        d="M3.93803 9.99796H15.3846C16.7406 9.99796 17.7396 9.844 18.4594 9.1243C19.1745 8.4092 19.3227 7.42358 19.3227 6.06561V3.93803C19.3227 2.58004 19.1745 1.59237 18.4594 0.874689C17.7339 0.158599 16.7406 0 15.3846 0H3.90538C2.58675 0 1.5877 0.158599 0.867978 0.879355C0.148246 1.59908 0 2.5847 0 3.91005V6.06561C0 7.42358 0.143581 8.41025 0.863312 9.1243C1.58873 9.844 2.58208 9.99796 3.93803 9.99796ZM3.73791 8.7484C2.92431 8.7484 2.20173 8.62631 1.781 8.2066C1.36493 7.79155 1.25059 7.08036 1.25059 6.2657V3.77056C1.25059 2.92795 1.36596 2.20845 1.781 1.79135C2.19605 1.36596 2.92898 1.25423 3.7659 1.25423H15.5848C16.3984 1.25423 17.121 1.37733 17.5417 1.79135C17.9577 2.21107 18.0721 2.92329 18.0721 3.73791V6.2657C18.0721 7.08036 17.9568 7.79051 17.5417 8.2066C17.122 8.63201 16.3984 8.7484 15.5848 8.7484H3.73791ZM20.303 6.91801C20.8928 6.88177 21.6769 6.12922 21.6769 5.00181C21.6769 3.87341 20.8928 3.1208 20.303 3.08565V6.91801Z"
        fill="white"
      />
      <path
        d="M3.49216 7.88769H15.8306C16.3731 7.88769 16.6967 7.80591 16.9115 7.59212C17.1253 7.37729 17.2081 7.05376 17.2081 6.51114V3.4908C17.2081 2.94355 17.1253 2.62464 16.9115 2.40984C16.6967 2.19606 16.3685 2.11426 15.8306 2.11426H3.52015C2.94957 2.11426 2.62134 2.19606 2.4112 2.40517C2.19741 2.61998 2.10992 2.95288 2.10992 3.51879V6.51114C2.10992 7.05842 2.19741 7.37729 2.4112 7.59212C2.626 7.80125 2.95424 7.88769 3.49216 7.88769Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_2323_6928">
        <rect width="21.8874" height="10" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const HSAFSAIcon = () => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.4977 15C11.6383 15 15 11.6419 15 7.50236C15 3.36171 11.6383 0 7.4977 0C3.35706 0 0 3.36171 0 7.50236C0 11.6419 3.35706 15 7.4977 15ZM7.4977 13.7039C4.06908 13.7039 1.29612 10.931 1.29612 7.50236C1.29612 4.07375 4.06908 1.29976 7.4977 1.29976C10.9262 1.29976 13.6993 4.07375 13.6993 7.50236C13.6993 10.931 10.9262 13.7039 7.4977 13.7039Z"
      fill="white"
    />
    <path
      d="M6.70311 10.9873C6.93806 10.9873 7.13522 10.8753 7.27264 10.6635L10.6713 5.35969C10.7565 5.2296 10.8304 5.07515 10.8304 4.92948C10.8304 4.61093 10.5454 4.39258 10.2476 4.39258C10.054 4.39258 9.87534 4.50619 9.74421 4.71784L6.68239 9.59334L5.17917 7.72221C5.02212 7.52173 4.86665 7.45465 4.6756 7.45465C4.36172 7.45465 4.11084 7.70812 4.11084 8.02563C4.11084 8.18052 4.17077 8.3262 4.27915 8.46507L6.11083 10.6666C6.28539 10.8866 6.46607 10.9873 6.70311 10.9873Z"
      fill="white"
    />
  </svg>
);

export const DesktopCarouselBanner = () => {
  const t = useTranslations('ring-pro');
  const { region } = useRegionLocale();
  const isUS = region?.toUpperCase() === 'US';

  return (
    <div className={styles.bannerWrapper}>
      {isUS && (
        <>
          <span className={styles.bannerItem}>
            <HSAFSAIcon />
            {t('ring-pro.banner.hsaFsa')}
          </span>
          <span className={styles.divider} />
        </>
      )}
      <span className={styles.bannerItem}>
        <Battery />
        {t('ring-pro.banner.batteryLife')}
      </span>
    </div>
  );
};
